import {I18n} from '@lingui/core';

export function getPayoutStatusI18n(status: string, i18n: I18n): string {
  const map: Record<string, string> = {
    booked: i18n._('Booked'),
    returned: i18n._('Returned'),
  };
  return map[status] ?? status;
}

export function getBankAccountTypeI18n(type: string, i18n: I18n): string {
  const map: Record<string, string> = {
    checking: i18n._('Checking'),
    savings: i18n._('Savings'),
  };
  return map[type] ?? type;
}
